import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import parse from 'html-react-parser';
import DisplayImage from '../display-image';
import {borderRadius, colors} from '@/styles/tokens';

const sxImgWrapper = {
    '@media (max-width: 320px)': {
        flexDirection: 'column',
        alignItems: 'unset'
    }
};

const developerImgStyle: React.CSSProperties = {
    borderRadius: borderRadius.circle,
    border: `5px solid ${colors.text.inverse}`,
    boxShadow: '0 0 10px rgb(0 0 0 / 0.3)',
    display: 'block'
};

const WebDeveloperProfile = (props: any) => {
    const {heading, subheading, contentData} = props;
    return (
        <Box>
            <MUIContainer>
                <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={5}>
                    <Typography variant="h1" component="h2" mb={3} fontSize={{xs: 35, sm: 48}} className="font-headers">
                        {heading}
                    </Typography>
                    <Typography variant="subtitle1" component="p" className="remove-link-underline font-regular-text">
                        {subheading ? parse(subheading) : ''}
                    </Typography>
                </Box>

                <Grid container spacing={3}>
                    {contentData?.map((item: any, index: number) => (
                        <Grid item md={6} xs={12} key={index + 1}>
                            <Box
                                borderRadius={7}
                                sx={{
                                    boxShadow: '0 0 0 6px rgba(10, 1, 99, 0.08)',
                                    p: 3,
                                    height: '100%'
                                }}
                            >
                                <Box className="height-full">
                                    <Box display="flex" mb={3} alignItems="center" gap={3} sx={sxImgWrapper}>
                                        <DisplayImage src={item.img} alt={item.name} width={120} height={120} style={developerImgStyle} />
                                        <Box>
                                            <Typography fontFamily="Headers, sans-serif" fontSize={{xs: 20, sm: 26}}>
                                                {item.name}
                                            </Typography>
                                            <Typography fontFamily="RegularText, sans-serif" mb={0.5}>
                                                {item.position}
                                            </Typography>
                                            <Typography fontFamily="RegularText, sans-serif">{item.experience}</Typography>
                                        </Box>
                                    </Box>
                                    <Box display="flex" flexWrap="wrap" gap={1.6} mb={1.5}>
                                        {item?.tags?.map((tag: any) => (
                                            <Typography fontFamily="RegularText, sans-serif" key={tag} bgcolor="#ECF4FD" p={1}>
                                                {tag}
                                            </Typography>
                                        ))}
                                    </Box>
                                    <Typography component="p" fontFamily="RegularText, sans-serif">
                                        {item.description ? parse(item.description) : ''}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </MUIContainer>
        </Box>
    );
};

export default memo(WebDeveloperProfile);
